module.exports = __webpack_public_path__ + "public/img/htpz.687dab2b.png";